module.exports = __webpack_public_path__ + "media/images/athletes/1458-a002ca913898ca1a0dc57aebd685e0b7.png";